import { 
  PublicClientApplication, 
  InteractionRequiredAuthError 
} from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID}`,
    //redirectUri: "http://localhost:3000"
    //redirectUri: "https://wapp-sdinsight-alz-tjx-prod-eu.cognizant.com/"
    //redirectUri: "https://172.178.59.169/"
    redirectUri: `${process.env.REACT_APP_MSAL_REDIRECT_URI}`
  },
  cache: { 
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
};

export const apiRequest = { 
 scopes: [`api://${process.env.REACT_APP_SERVER_APP_CLIENT_ID}/tasks.read`, `api://${process.env.REACT_APP_SERVER_APP_CLIENT_ID}/tasks.write`]
}

export const loginRequest = { 
  scopes: ["User.Read"]
}

export const authRequest = { 
  scopes: ["openid", "profile"]
}

/**
 * Reusable access token helper for MSAL in SPAs.
 *
 * @param {PublicClientApplication} instance - msal instance (from useMsal() or msalContext)
 * @param {AccountInfo} account - active account (usually accounts[0])
 * @param {object} requestBase - e.g. { scopes: ["api://.../tasks.read"] }
 * @returns {Promise<string|null>} access token string or null
 */
export async function getAccessToken(instance, account, requestBase = apiRequest) {
  if (!instance || !account) return null;

  const request = { ...requestBase, account };

  try {
    const result = await instance.acquireTokenSilent(request);
    // MSAL returns the token on `accessToken` (string)
    return result && result.accessToken ? result.accessToken : null;
  } catch (error) {
    // If user interaction is required, fall back to popup (or redirect)
    if (error instanceof InteractionRequiredAuthError) {
      const result = await instance.acquireTokenPopup(request);
      return result && result.accessToken ? result.accessToken : null;
    }

    console.error(error);
    return null;
  }
}

export const msalInstance = new PublicClientApplication(msalConfig);